import requester from '@/utils/request'
export const userService = {
  // 获取今天登陆人数
  queryTodayJoinNum: () => requester.post('/user/common/v1/queryTodayJoinNum'),
  // 添加国家
  addCountry: (country: string) => requester.post(`/black-business/add-country?country=${country}`),
  // 查询设置的国家黑名单
  findCountry: () => requester.post('/black-business/find-country'),
  // 移除国家
  removeCountry: (country: string) =>
    requester.post(`/black-business/remove-country?country=${country}`),
  // 添加IP
  addIp: (ip: string) => requester.post(`/black-business/add-ip?ip=${ip}`),
  // 查询设置的IP黑名单
  findIP: () => requester.post('/black-business/find-ip'),
  // 移除IP
  removeIP: (ip: string) => requester.post(`/black-business/remove-ip?ip=${ip}`),
  // 获取share余额 及 汇率
  getShareBalance: (data: any) => requester.post('/user/revenue/flow/get-share-balance', data),
  // 获取share记录
  findShareRecord: (data: any) => requester.post('/user/revenue/flow/find-share-record', data),
  // 用户上传kyc资料
  uploadKycInfo: (data: any) => requester.post('/kyc-task/v1/uploading-info', data),
  // 获取kyc 详情
  getKycData: () => requester.post('/kyc-task/v1/detail', {}),
  sendKycLinkToEmail: (data: { email: string }) => requester.post('/kyc-task/v1/email/send', data),
  // dismiss kyc 任务
  dismissKyc: () => requester.post('/kyc-task/v1/dismiss', {}),
  // 用户自己增加kyc任务
  addKycTask: () => requester.post('/kyc-task/v1/task/add', {}),
  // contact 发送邮件
  contactUs: (data: any) => requester.post('/no-login/v1/contact-us', data),
  // 获取下载设置
  settingDownload: () => requester.post('/seller/creator-post-download/getOpenStatus', {}),
  // 开启下载设置
  openDownload: () => requester.post('/seller/creator-post-download/open', {}),
  // 关闭下载设置
  closeDownload: () => requester.post('/seller/creator-post-download/close', {}),
  // 获取入驻提醒的dismiss记录
  dismissRecord: () =>
    requester.post('/seller/encourage-creator-dismiss-record/v1/dismiss-record/get', {}),
  // 获取入驻提醒的dismiss记录 用户dismiss
  fansDismiss: () => requester.post('/seller/encourage-creator-dismiss-record/v1/dismiss', {}),
  // 获取当前用户进行中的提醒
  homeRemind: () => requester.post('/seller/home-remind/in-progress/query', {}),
  // 添加地址
  addAccountAddress: (data: any) => requester.post('/actor/v1/add-address', data),
  // 添加fullname
  addAccountFullName: (data: any) => requester.post('/actor/v1/add-full-name', data),
  // 获取用户所属国家的接口
  getUserCountry: () => requester.post('/dfans/get-user-country', {}),
  // 获取kyc链接
  getKycLink: (data: any) => requester.post('/kyc-task/v1/url/generate', data),
  // 用户获取自己当前kyc region document info
  getKycRegionDocumentInfo: () => requester.post('/kyc-task/v1/document/get', {}),
  // 用户根据自己选择的region获取kyc document info
  getKycDocumentInfo: (data: any) => requester.post('/kyc-task/v1/document/by-region', data),
  // kyc支持国家列表
  getKycSupportCountry: () => requester.post('/kyc-task/v1/region/support', {}),
  // 申请union pay 和 alipay 支付
  applyUnionPayAlipayPayments: () => requester.post('/seller/alipay/apply', {}),
  // 获取申请状态
  getApplyUnionPayAlipayPayments: () => requester.post('/seller/alipay/status', {}),
  // FiatPayments 发起申请
  applyFiatPayment: () => requester.post('/seller/fiat-payment/apply', {}),
  //FiatPayments 查看申请
  getFiatPaymentStatus: () => requester.post('/seller/fiat-payment/status', {}),
  // 添加昵称备注
  addNicknameNote: (data: any) => requester.post('/chat-msg/v1/add-nickname-note', data),
  // 创作者设置是否可以被搜索到
  setSearchHidden: (data: any) => requester.post('/shop/search-hidden/set', data),
  // 查询是否设置昵称 搜索
  querySearchHidden: () => requester.post('/shop/search-hidden/info', {}),
  // 获取最近访问的创作者
  getRecentVisitedCreators: () => requester.post('/common/creator/visited', {}),
  // 申请USDEarningsWithdrawal
  applyUSDEarningsWithdrawal: () => requester.post('/seller/usd-earnings-withdrawal/apply', {}),
  // 获取USDEarningsWithdrawal申请状态
  getUSDEarningsWithdrawalStatus: () =>
    requester.post('/seller/usd-earnings-withdrawal/status', {}),
  // 生成粉丝邀请码
  invitationCodeGenerate: () => requester.post('/actor/v1/invitation-code/generate', {}),
  // 获取创作者水印设置
  getCreatorWatermark: () =>
    requester.post('/seller/creator-business-switch/queryWatermarkText', {}),
  // 设置创作者水印设置
  setCreatorWatermark: (data: any) =>
    requester.post('/seller/creator-business-switch/setWatermarkSwitch', data),
}
